import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DeliveryTrip } from "../../../../data/entities";

dayjs.extend(utc);

export const normalizeDeliveryTrip = (trip: any): DeliveryTrip & { _persisted: boolean } => ({
    id: trip.id,
    trip_number: trip.trip_number ?? null,
    status: trip.status,
    has_edits: trip.has_edits,
    show_edited_badge: trip.show_edited_badge,
    edit_count: trip.edit_count,
    edit_history: trip.edit_history,
    vehicle_plate: trip.vehicle_plate || trip.car_plate,
    scheduled_at: trip.scheduled_at !== undefined ? trip.scheduled_at : (trip.date ? dayjs(trip.date).utc().format("YYYY-MM-DDTHH:mm:ss") : undefined),
    notes: trip.notes || trip.note || "",
    carrier_name: trip.carrier_name || "",
    carrier_phone: trip.carrier_phone || "",
    delivery_address: trip.delivery_address ?? null,
    is_imported: trip.is_imported || false,
    is_exported: trip.is_exported || false,
    is_first_storage_keeper_imported: trip.is_first_storage_keeper_imported || false,
    is_second_storage_keeper_imported: trip.is_second_storage_keeper_imported || false,
    is_first_storage_keeper_exported: trip.is_first_storage_keeper_exported || false,
    is_second_storage_keeper_exported: trip.is_second_storage_keeper_exported || false,
    delivery_products: trip.delivery_products || trip.items || [],
    _persisted: true,
    ...(trip.arrived_at && { arrived_at: trip.arrived_at }),
    ...(trip.departure_at && { departure_at: trip.departure_at }),
    ...(trip.created_at && { created_at: trip.created_at }),
    ...(trip.edited_at && { edited_at: trip.edited_at }),
});
